



























import { Vue, Component } from 'vue-property-decorator'

@Component
export default class App extends Vue {

  drawer: boolean = false;
  menus: Array<any> = [
    { icon: 'home', title: 'Home', path: '/' },
    { icon: 'list', title: 'Category', path: '/category' },
    { icon: 'view_list', title: 'All', path: '/all' },
    { icon: 'build', title: 'Random', path: '/random' }
  ]

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue